export default __webpack_public_path__ + "asset/nepal.2611c69df92705b8d2bd9bcb85eb9d19.svg";